import { 
  Home, 
  Newspaper,
  Rss, 
  Store, 
  Wallet, 
  GraduationCap, 
  Plane, 
  Gamepad2, 
  Music2, 
  UtensilsCrossed, 
  Settings, 
  MessageSquare, 
  Bell, 
  Users, 
  UsersRound, 
  Globe, 
  Bot, 
  BarChart3, 
  Pi as Pick, 
  Zap, 
  Calendar, 
  HeartHandshake, 
  HandHeart, 
  Ticket, 
  Navigation,
  UserCircle,
  Tag,
  ScrollText,
  Gift,
  Award,
  Bus,
  Train,
  Ship,
  Car,
  BedDouble,
  Briefcase,
  ShoppingBasket,
  Shield,
  HelpCircle,
  FileText,
  UserCog,
  Lock,
  ChefHat,
  Hotel,
  UserCheck,
  TrendingUp,
  LineChart,
  Package,
  ShoppingCart,
  BarChart,
  Crown,
  CreditCard,
  Video,
  Megaphone,
  PawPrint,
  Accessibility,
  // Adding solid/filled versions for better visual consistency
  MessageCircle,
  BellRing,
  User,
  Activity
} from 'lucide-react';

// All navigation items with their icons and paths
export const NAVIGATION_ITEMS = [
  // Main Navigation - Using solid/filled style icons
  { icon: Home, label: 'Home', path: '/' },
  { icon: Newspaper, label: 'News', path: '/news' },
  { icon: Rss, label: 'Feed', path: '/feed' },
  { icon: User, label: 'Profile', path: '/profile' },
  { icon: PawPrint, label: 'Pets', path: '/pets' },
  { icon: MessageCircle, label: 'Messages', path: '/messages' },
  { icon: BellRing, label: 'Notifications', path: '/notifications' },
  { icon: Users, label: 'Friends', path: '/friends' },

  // Content & Social
  { icon: UsersRound, label: 'Groups', path: '/groups' },
  { icon: Globe, label: 'Pages', path: '/pages' },
  { icon: Calendar, label: 'Events', path: '/events' },
  { icon: Video, label: 'Videos', path: '/videos' },
  { icon: Music2, label: 'Music', path: '/music' },

  // Services & Commerce
  { icon: Store, label: 'Marketplace', path: '/marketplace' },
  { icon: Package, label: 'My Products', path: '/my-products' },
  { icon: BedDouble, label: 'Bookings', path: '/bookings' },
  { icon: Home, label: 'Rentals', path: '/rentals' },
  { icon: UtensilsCrossed, label: 'Food', path: '/food' },
  { icon: ChefHat, label: 'Recipes', path: '/recipes' },
  { icon: Navigation, label: 'Transportation', path: '/transportation' },
  { icon: Ticket, label: 'Tickets', path: '/tickets' },
  { icon: ScrollText, label: 'Classifieds', path: '/classifieds' },
  { icon: Tag, label: 'Coupons', path: '/coupons' },
  { icon: Megaphone, label: 'Boost', path: '/boost' },
  { icon: Briefcase, label: 'Freelance', path: '/freelance' },
  { icon: ShoppingBasket, label: 'Groceries', path: '/groceries' },

  // Learning & Games
  { icon: GraduationCap, label: 'Learning', path: '/learning' },
  { icon: Gamepad2, label: 'Games', path: '/games' },
  { icon: Bot, label: 'AI Assistant', path: '/ai' },

  // Finance & Crypto
  { icon: Wallet, label: 'Wallet', path: '/wallet' },
  { icon: CreditCard, label: 'Credit Card', path: '/credit-card' },
  { icon: LineChart, label: 'Crypto Atlas', path: '/crypto-atlas' },
  { icon: BarChart3, label: 'Exchange', path: '/exchange' },
  { icon: Pick, label: 'Mining', path: '/mining' },
  { icon: Zap, label: 'Staking', path: '/staking' },

  // Charity & Rewards
  { icon: HeartHandshake, label: 'Charity', path: '/charity' },
  { icon: HandHeart, label: 'Crowdfunding', path: '/crowdfunding' },
  { icon: Gift, label: 'Rewards', path: '/rewards' },

  // Transportation
  { icon: Plane, label: 'Flights', path: '/transportation/airline' },
  { icon: Train, label: 'Trains', path: '/transportation/train' },
  { icon: Bus, label: 'Buses', path: '/transportation/bus' },
  { icon: Ship, label: 'Ferries', path: '/transportation/ferry' },
  { icon: Car, label: 'Taxi', path: '/transportation/taxi' },

  // Admin & Seller (conditionally shown based on user role)
  { icon: Crown, label: 'Super Admin', path: '/admin/super-admin-dashboard', superAdminOnly: true },
  { icon: Activity, label: 'Telemetry Ops', path: '/admin/telemetry', adminOnly: true },
  { icon: UserCog, label: 'Debug Panel', path: '/admin/debug', superAdminOnly: true },
  { icon: UserCheck, label: 'Admin Dashboard', path: '/admin/dashboard', adminOnly: true },
  { icon: Pick, label: 'Admin Mining', path: '/admin/mining', adminOnly: true },
  { icon: TrendingUp, label: 'Seller Dashboard', path: '/seller/dashboard', sellerOnly: true },
  { icon: Package, label: 'My Products', path: '/seller/products', sellerOnly: true },
  { icon: ShoppingCart, label: 'My Orders', path: '/seller/orders', sellerOnly: true },
  { icon: BarChart, label: 'Sales Analytics', path: '/seller/analytics', sellerOnly: true },

  // Settings & Support
  { icon: Settings, label: 'Settings', path: '/settings' },
  { icon: Accessibility, label: 'Accessibility Settings', path: '/accessibility' },
  { icon: Shield, label: 'Privacy Settings', path: '/privacy' },
  { icon: Lock, label: 'KYC Verification', path: '/kyc' },
  { icon: HelpCircle, label: 'Help Center', path: '/help' },
  { icon: FileText, label: 'Documentation', path: '/docs' }
];

// Navigation categories for sidebar organization
export const NAVIGATION_CATEGORIES = {
  main: [
    'Home', 'News', 'Feed', 'Profile', 'Pets', 'Messages', 
    'Notifications', 'Friends'
  ],
  content: [
    'Groups', 'Pages', 'Events', 'Videos', 'Music'
  ],
  services: [
    'Marketplace', 'My Products', 'Bookings', 'Rentals', 'Food', 'Recipes', 'Transportation', 
    'Boost',
    'Tickets', 'Classifieds', 'Coupons', 'Freelance', 'Groceries'
  ],
  entertainment: [
    'Learning', 'Games', 'AI Assistant'
  ],
  finance: [
    'Wallet', 'Credit Card', 'Crypto Atlas', 'Exchange', 'Mining', 'Staking'
  ],
  charity: [
    'Charity', 'Crowdfunding', 'Rewards'
  ],
  transport: [
    'Flights', 'Trains', 'Buses', 'Ferries', 'Taxi'
  ],
  business: [
    'Super Admin', 'Telemetry Ops', 'Debug Panel', 'Admin Dashboard', 'Admin Mining', 'Seller Dashboard', 
    'My Products', 'My Orders', 'Sales Analytics'
  ],
  support: [
    'Settings', 'Accessibility Settings', 'Privacy Settings', 'KYC Verification',
    'Help Center', 'Documentation'
  ]
};